import { serviceRoles } from "config/access";
import { SUBSCRIPTIONS } from "constants/routes";
import { checkAccess } from "helpers/auth";
import Page from "./container/SubscriptionsPage";

export default function getSettingsRoute(userAuth) {
  const { account, postal } = serviceRoles;
  const requireAuth = {
    [account.name]: [account.roles.superadmin],
    [postal.name]: [postal.roles.user],
  };
  return {
    requireAuth,
    onEnter: () => checkAccess(requireAuth, userAuth),
    path: SUBSCRIPTIONS,
    withSidebar: true,
    withAppBar: true,
    component: Page,
  };
}
